import { GridProduct, SkinProduct } from '../types/productTypes'

import {
  ErrorSkin,
  ErrorSkinOther,
  ErrorSkinSocket,
  PlaceholderSkin,
  PlaceholderSkinOther,
  PlaceholderSkinSocket,
  PlaceholderSkinSocketVertical,
} from './placeholderImages'

export function getSkinPlaceholderImage(skin: SkinProduct, grid: GridProduct | null) {
  switch (grid?.type) {
    case 'Socket': return skin.imageOrientation === 'Horizontal' ? PlaceholderSkinSocket : PlaceholderSkinSocketVertical
    case 'Other': return PlaceholderSkinOther
  }

  return PlaceholderSkin
}

export function getSkinErrorImage(skin: SkinProduct, grid: GridProduct | null) {
  switch (grid?.type) {
    case 'Socket': return ErrorSkinSocket
    case 'Other': return ErrorSkinOther
  }

  return ErrorSkin
}
